{
  "name": "patch-mgmt-admin-webapp",
  "version": "1.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:dev": "ng build --configuration dev",
    "build:test": "ng build --configuration test",
    "build:prod": "ng build --configuration prod",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.18",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.18",
    "@angular/compiler": "^20.3.18",
    "@angular/core": "^20.3.18",
    "@angular/forms": "^20.3.18",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.18",
    "@angular/platform-browser-dynamic": "^20.3.18",
    "@angular/router": "^20.3.18",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "angular-oauth2-oidc": "^17.0.2",
    "angular-oauth2-oidc-jwks": "^17.0.2",
    "bootstrap": "^5.3.3",
    "deepmerge": "^4.3.1",
    "js-sha256": "^0.9.0",
    "ngx-mat-select-search": "^8.0.4",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.22",
    "@angular/cli": "^20.3.22",
    "@angular/compiler-cli": "^20.3.18",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^20.16.5",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "5.8"
  }
}
